import React, { useContext } from 'react'
import { ReducerContext } from '../reducers/reducerContext.js';
import MessageI18N from '../helpers/MessageI18N'

export default function ContMessageI18N(props) {

	const globalstate = useContext(ReducerContext);
	let actualState = {};
	if (globalstate != null && globalstate.context != null) {
		actualState = { actualLanguage: globalstate.actualLanguage, context: globalstate.context }
	} else if(globalstate != null) {
		actualState = { actualLanguage: globalstate.settings.actualLanguage, context: globalstate.testCriteria.context }
	}
	return (
		<MessageI18N
			actualLanguage={actualState.actualLanguage}
			context={actualState.context}
			i18n={props.i18n}
			optionValue={props.optionValue}
			optionStyle={props.optionStyle}
			arg={props.arg}
			argType={props.argType}
			prefix={props.prefix}
			removeI18NPrefix={props.removeI18NPrefix}
			callBackText={props.callBackText}
		/>
	);

}
